export function getBrowserType() {
    let userAgent = navigator.userAgent;
    let browserName = 'Unknown';

    if (userAgent.indexOf('Chrome') > -1 && userAgent.indexOf('Edg') === -1 && userAgent.indexOf('OPR') === -1) {
        browserName = 'Google Chrome';
    } else if (userAgent.indexOf('Safari') > -1 && userAgent.indexOf('Chrome') === -1) {
        browserName = 'Safari';
    } else if (userAgent.indexOf('Firefox') > -1) {
        browserName = 'Mozilla Firefox';
    } else if (userAgent.indexOf('MSIE') > -1 || userAgent.indexOf('Trident') > -1) {
        browserName = 'Internet Explorer';
    } else if (userAgent.indexOf('Edg') > -1) {
        browserName = 'Microsoft Edge';
    } else if (userAgent.indexOf('OPR') > -1 || userAgent.indexOf('Opera') > -1) {
        browserName = 'Opera';
    }

    return browserName;
}

export function getDeviceType() {
    const width = window.innerWidth;
    const ua = navigator.userAgent.toLowerCase();

    const isSmartTV =
        ua.includes('smart-tv') ||
        ua.includes('smarttv') ||
        ua.includes('hbbtv') ||
        ua.includes('appletv') ||
        ua.includes('googletv') ||
        ua.includes('tizen') ||
        ua.includes('webos');

    if (isSmartTV) {
        return 'SmartTV';
    }

    if (width > 1023) {
        return 'Desktop';
    } else if (width > 767) {
        return 'Tablet';
    } else {
        return 'Mobile';
    }
}
